import { styled } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScRegSliderFocus = styled.div`
  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    width: 100%;

    .title {
      ${typography['headline1mobile']}
      color: ${({ theme }) => theme.yellowColor};
      letter-spacing: 0.84px;
      text-transform: uppercase;
      width: 100%;
      text-align: center;
      margin-bottom: 24px;
      white-space: nowrap;
    }

    .subtitle {
      ${typography['body2regular']}
      color: ${({ theme }) => theme.whiteColor};
      margin-top: 8px;
    }

    .button {
      margin-top: 24px;
      font-weight: 700;
      line-height: 18px;
      letter-spacing: 0.16px;
      width: 100%;
    }

    .banks {
      display: flex;
      gap: 12px;
      margin-top: 24px;
      height: 20px;
      width: 100%;
    }

    .bank-img {
      display: flex;
      object-fit: contain;
    }
  }
`;

export const ScBonusContainer = styled.div`
  @media (${device.mobile}) {
    text-align: center;

    .max-sum {
      font-size: 56px;
      font-weight: 700;
      letter-spacing: 1.68px;
      text-transform: uppercase;
      text-align: center;
      margin-top: -35px;
    }

    .bonus {
      ${typography['headline1mobile']}
      text-transform: uppercase;
    }
  }
`;
